import { render, staticRenderFns } from "./AddFloater.vue?vue&type=template&id=19740aa7&scoped=true&"
import script from "./AddFloater.vue?vue&type=script&lang=js&"
export * from "./AddFloater.vue?vue&type=script&lang=js&"
import style0 from "./AddFloater.vue?vue&type=style&index=0&id=19740aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19740aa7",
  null
  
)

export default component.exports